/**
 *  统计分析报表
 */
import http from '../assets/js/http'
// 考试总体分析
export const ksfxPage = (params) => { return http.request({ url: '/report/ksfxPage', method: 'get', params: params }) }
// 试题总体分析
export const stfxPage = (params) => { return http.request({ url: '/report/stfxPage', method: 'get', params: params }) }
// 试题页面
export const stPage = (params) => { return http.request({ url: '/report/stPage', method: 'get', params: params }) }
// 部门总体分析
export const bmfxPage = (params) => { return http.request({ url: '/report/bmfxPage', method: 'get', params: params }) }
// 考生总体分析
export const ksfx = (params) => { return http.request({ url: '/report/ksfx', method: 'get', params: params }) }
// 考生错题分析
export const ctfx = (params) => { return http.request({ url: '/report/ctfx', method: 'get', params: params }) }
// 获取考生考试成绩
export const examScoreList = (params) => { return http.request({ url: '/report/examScoreList', method: 'get', params: params }) }
// 获取考试列表获取-无分页
export const getKsnameList = (params) => { return http.request({ url: '/report/getKsnameList', method: 'get', params: params }) }
// 获取未考试考生
export const getWkList = (params) => { return http.request({ url: '/report/getWkList', method: 'get', params: params }) }
// 试题分类列表
export const stflList = (params) => { return http.request({ url: '/report/stflList', method: 'get', params: params }) }
